/** @jsx jsx */
import { jsx, Box } from "theme-ui";

// Can't use prop name sx as it will be swallowed before getting here.
const PageSection = ({as, children, ...rest}) => {
  return (
    <Box
      variant="section"
      as={as || "section"}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default PageSection;
